import React from "react";
import ReactDOM from "react-dom";

import { AppStorage, StorageContext } from "@tableplus/toolkit";
import { App } from "./app/app";

const storage = new AppStorage("json");

ReactDOM.render(
    <React.StrictMode>
        <StorageContext.Provider value={storage}>
            <App />
        </StorageContext.Provider>
    </React.StrictMode>,
    document.getElementById("root")
);
